import React, { useEffect } from "react";
import Logo from "../assets/cbre_logo.png";
import {
	// useNavigate,
	useLocation,
	// Link 
} from "react-router-dom";
// import { useLocation, useNavigate } from "react-router-dom";
// import NavigateIcon from "../assets/navigation_icon.png";
import DiroLogoTrans from "../assets/diro_logo_white.png";
import { useContext } from "react";
import { Context } from "../context";

const Header = ({
	//redirect,
	iframeRef
}) => {
	const location = useLocation();
	const {
		// inputEmail,
		setPrevPage,
		toggleSideBar,
		setToggleSideBar,
		// prevPage
	} = useContext(Context);
	console.log("location", location.pathname);

	// const navigate = useNavigate();
	//***** Receives message from capture-process when Exit button is clicked *****
	// window.addEventListener("message", function (e) {
	// 	console.log("EventListnerData::>", e.data);
	// 	if (e.data === "Terminate session from guac" && location.pathname === "/verification") {
	// 		navigate("/buttons");
	// 	}
	// });
	const toggleSidebar = ()=>{
		setToggleSideBar(!toggleSideBar)
	}
	useEffect(() => {
		setPrevPage(location.pathname);
		// console.log(prevPage, "===============prevPage=======================");
	}, [location, setPrevPage]);

	const handleLogoClick = () => {
		// ===== Post message to capture-process iframe to open the exit survey page =====
		if (location.pathname === "/verification") iframeRef?.current?.children[0]?.contentWindow.postMessage("Exit cbre session", "*");
	};
	// const redirectToHome = () => {
	// 	if (inputEmail && location.pathname === "/buttons" && location.pathname === "/verification") {
	// 		navigate("/buttons");
	// 	}
	// };
	// const navigate = useNavigate();
	// const location = useLocation();

	const handleFocus = () => {
		console.log("handleFocus")
		iframeRef?.current?.children[0].focus();
	}
	
	const handleClickOutside = (event) => {
		if(window.location.href.includes("/verification")){
			event.preventDefault();
			handleFocus()
		}
		};

	document.addEventListener("mousedown", handleClickOutside);
	return (
		<div className={`header-container ${window.location.href.includes("verification") &&"header-container-thin"}`}>
			{/* <div style={{"width":"35px", "height":"35px"}}>
				{location.pathname !== "/" ? <img className="navigate-img" src={NavigateIcon} alt="Go back" onClick={() => navigate("/")} /> : ""}
			</div> */}

			<div className="logo_wrap">
				<img className="main-logo" src={Logo} alt="cbre logo" onClick={handleLogoClick} />
				{/* <i id="icon1" className={`bi ${sidebarToggle ? "bi-arrow-bar-left" : "bi-list"}`}></i> */}

				{window.location.href.includes("verification") && 
				<button onClick={toggleSidebar} className="mobiles-sidebar-toggle" id="toggle"title="Toggle sidebar">
						{/* <i id="icon-toggle-sidebar-mobile" className="bi-list"></i> */}
						<i id="icon1" className={`bi ${toggleSideBar ? "bi-arrow-bar-left" : "bi-list"}`}></i>
					</button>
				}
				
			</div>
			{/* {redirect ? (
				<Link className="logo_wrap" to="/buttons" >
					<img className="main-logo" src={Logo} alt="cbre logo" />
				</Link>
			) : (
				<div className="logo_wrap">
					<img className="main-logo" src={Logo} alt="cbre logo" />
				</div>
			)} */}
			<div className="d-flex top_bar_quotes">
				<p className="header_quotation">Supplier Shield <span className="dash_unnderscore"></span> Supplier Onboarding:<br />Bank account and address verification</p>
				<p className="header_quotation">
					<span className="d-none d-md-block">&nbsp;</span>Powered by <img className="diro-logo-trans" src={DiroLogoTrans} alt="Diro Logo" />
				</p>
			</div>
			
		</div>
	);
};

export default Header;
